<template>
  <div class="body">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane name="first" label="预约信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{appointmentOrderVO.billNo}}</td>
            <td class="tableLabel">登记人：</td>
            <td>{{appointmentOrderVO.creatorName}}</td>
            <td class="tableLabel">提交时间：</td>
            <td>{{appointmentOrderVO.submitTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预约日期：</td>
            <td>{{appointmentOrderVO.appointmentTime}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{appointmentOrderVO.factoryNo}}</td>
            <td class="tableLabel">现场名称：</td>
            <td>{{appointmentOrderVO.siteName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称：</td>
            <td>{{appointmentOrderVO.customerName}}</td>
            <td class="tableLabel">销售员：</td>
            <td>{{appointmentOrderVO.salesmanName}}</td>
            <td class="tableLabel">销售联系方式：</td>
            <td>{{appointmentOrderVO.salesMobile}}</td>
          </tr>
          <tr>
            <td class="tableLabel">现场联系人：</td>
            <td>{{appointmentOrderVO.contact}}</td>
            <td class="tableLabel">现场联系方式：</td>
            <td>{{appointmentOrderVO.siteMobile}}</td>
            <td class="tableLabel">项目负责人：</td>
            <td>{{appointmentOrderVO.projectLeader}}</td>
          </tr>
          <tr>
            <td class="tableLabel">服务台数：</td>
            <td>{{appointmentOrderVO.serviceQuantity}}</td>
            <td class="tableLabel">主板型号：</td>
            <td>{{appointmentOrderVO.mainBoardModel}}</td>
            <td class="tableLabel">变频器型号：</td>
            <td>{{appointmentOrderVO.transducerModel}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预估完成工时：</td>
            <td>
              <el-input v-model="appointmentOrderVO.estimatedFinishTime" :disabled="nodeId!=='csManagerApprove'"/>
            </td>
            <td class="tableLabel">实际完成时间：</td>
            <td>
              <el-input v-model="appointmentOrderVO.actualFinishTime" disabled/>
            </td>
            <td class="tableLabel">数据来源：</td>
            <td>{{appointmentOrderVO.dataSources}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电梯云用户：</td>
            <td>{{appointmentOrderVO.elevatorUsers}}</td>
            <td class="tableLabel">终端客户：</td>
            <td>{{appointmentOrderVO.terminalCustomer}}</td>
            <td class="tableLabel">电梯云销售员：</td>
            <td>{{appointmentOrderVO.salesName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">服务地址：</td>
            <td colspan="5">{{appointmentOrderVO.serviceAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">故障描述：</td>
            <td colspan="5">{{appointmentOrderVO.faultNote}}</td>
          </tr>
          <tr>
            <td class="tableLabel">服务性质:</td>
            <td colspan="5">
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems1" disabled>
                <el-checkbox v-for="item in appointmentItemTemplates1" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">服务原因:</td>
            <td colspan="5">
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems2" disabled>
                <el-checkbox v-for="item in appointmentItemTemplates2" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="second" label="现场支持">
        <table
            v-if="nodeId==='siteSupport'"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">现场情况描述：</td>
            <td>
              <el-input v-model="appointmentOrderVO.siteDescription" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">责任判定：</td>
            <td>
              <el-select v-model="appointmentOrderVO.questionType" clearable placeholder="请选择">
                <el-option label="客户要求配合(收费)" :value="2"/>
                <el-option label="客户工地原因(收费)" :value="21"/>
                <el-option label="客户要求配合(不收费)" :value="22"/>
                <el-option label="我司供应商原因(不收费)" :value="3"/>
                <el-option label="我司生产原因(不收费)" :value="31"/>
                <el-option label="我司其它原因(不收费)" :value="32"/>
                <el-option label="我司研发待分析(不收费)" :value="4"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">问题分类：</td>
            <td>
              <el-select v-model="appointmentOrderVO.questionType" clearable placeholder="请选择">
                <el-option label="错" :value="1"/>
                <el-option label="漏" :value="2"/>
                <el-option label="质量" :value="3"/>
                <el-option label="运输损坏" :value="4"/>
                <el-option label="其他" :value="5"/>
              </el-select>
            </td>
            <td class="tableLabel">责任部门：</td>
            <td>
              <el-input v-model="appointmentOrderVO.responsibilityDepartment" placeholder="请输入" type="textarea"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">现场情况描述：</td>
            <td>
              {{appointmentOrderVO.siteDescription}}
            </td>
            <td class="tableLabel">责任判定：</td>
            <td>
              <el-select v-model="appointmentOrderVO.responsibilityDecide" disabled clearable placeholder="请选择">
                <el-option label="客户要求配合(收费)" :value="2"/>
                <el-option label="客户工地原因(收费)" :value="21"/>
                <el-option label="客户要求配合(不收费)" :value="22"/>
                <el-option label="我司供应商原因(不收费)" :value="3"/>
                <el-option label="我司生产原因(不收费)" :value="31"/>
                <el-option label="我司其它原因(不收费)" :value="32"/>
                <el-option label="我司研发待分析(不收费)" :value="4"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">问题分类：</td>
            <td>
              <el-select v-model="appointmentOrderVO.questionType" disabled clearable placeholder="请选择">
                <el-option label="错" :value="1"/>
                <el-option label="漏" :value="2"/>
                <el-option label="质量" :value="3"/>
                <el-option label="运输损坏" :value="4"/>
                <el-option label="其他" :value="5"/>
              </el-select>
            </td>
            <td class="tableLabel">责任部门：</td>
            <td>
              {{appointmentOrderVO.responsibilityDepartment}}
            </td>
          </tr>
        </table>
        <table
            v-if="nodeId.includes('siteSupport')"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">服务性质：</td>
            <td>
              <el-checkbox-group v-model="appointmentOrderVO.appointmentItems1">
                <el-checkbox v-for="item in appointmentItemTemplates1" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">其他性质：</td>
            <td>
              <el-input v-model="appointmentOrderVO.natureNote" placeholder="请输入"/>
            </td>
            <td class="tableLabel">实际完成工时：</td>
            <td>
              <el-input v-model="appointmentOrderVO.actualFinishTime"/>
            </td>
          </tr>
        </table>
        <table
            v-if="nodeId==='siteSupport'"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">是否收费：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCharge" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">要求收费日期：</td>
            <td>
              <el-date-picker
                  v-model="appointmentOrderVO.chargeDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">是否收费：</td>
            <td>{{appointmentOrderVO.isCharge?"是":"否"}}</td>
            <td class="tableLabel">要求收费日期：</td>
            <td>{{appointmentOrderVO.chargeDate}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="three" label="报价处理">
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">报价单信息</div>
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="$refs.addPriceSheet.open(-1,null)">
              新建
            </el-button>
          </div>
          <el-table
              ref="appointmentPriceSheets"
              :data="appointmentOrderVO.appointmentPriceSheets">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="项目名称"/>
            <el-table-column prop="serviceContent" align="center" label="服务内容"/>
            <el-table-column prop="chargeReason" align="center" label="收费原因"/>
            <el-table-column prop="price" align="center" label="价格"/>
            <el-table-column prop="note" align="center" label="备注"/>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="120px">
              <template slot-scope="scope">
                <el-button type="primary" @click="$refs.addPriceSheet.open(scope.$index,scope.row)">编辑</el-button>
                <el-button type="danger" @click="oneDeletePriceSheet(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="收费确认">
        <table
            v-if="nodeId==='costConfirmation'"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">客户是否同意收费：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCustomerAgree" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">不同意原因：</td>
            <td>
              <el-input v-model="appointmentOrderVO.disagreeReasons" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">收费订单号：</td>
            <td>
              <el-input v-model="appointmentOrderVO.chargeOrderNo" placeholder="请输入" type="textarea"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">客户意见：</td>
            <td>{{appointmentOrderVO.isCustomerAgree?"是":"否"}}</td>
            <td class="tableLabel">不同意原因：</td>
            <td>{{appointmentOrderVO.disagreeReasons}}</td>
            <td class="tableLabel">收费订单号：</td>
            <td>{{appointmentOrderVO.chargeOrderNo}}</td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">申请延期</div>
          <el-table
              ref="yqDate">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="审批人"/>
            <el-table-column prop="serviceContent" align="center" label="申请延期时间"/>
            <el-table-column prop="chargeReason" align="center" label="申请时间"/>
            <el-table-column prop="price" align="center" label="申请人"/>
            <el-table-column prop="note" align="center" label="审批意见"/>
            <el-table-column prop="note" align="center" label="备注"/>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
        <el-upload
            :action="actionUrl"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handlerError"
            :file-list="files"
            :show-file-list="false">
          <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
        </el-upload>
      </div>
      <el-table
          ref="payData1"
          :data="appointmentOrderVO.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
            <el-button type="danger" @click="oneDelete(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">现场照片</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.siteAttachments"
            :key="item.accessoryID"
            style="width: 100px; height: 100px;margin-right: 10px"
            :src="item.fileFullPath"
            :preview-src-list="srcList"/>
      </div>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">客户签名</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.signatureAttachments"
            :key="item.accessoryID"
            style="width: 100px; height: 100px;border: 1px solid #ccc;border-radius: 5px;margin-right: 10px"
            :src="item.fileFullPath"
            :preview-src-list="srcList"/>
      </div>
    </div>
    <add-price-sheet ref="addPriceSheet" @save-success="addPriceSheets"/>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import AddPriceSheet from "@/views/afterSalesManagement/Appointment/AddPriceSheet";

  export default {
    name: "",
    components: {AddPriceSheet, HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        uploadLoading:false,
        srcList:[],
        imgUrls:[],
        files: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        nodeId: "",
        activeName: "first",
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: "",
          debugName: "",
          debugId: "",
          customerId: "",
          customerName: "",
          salesmanId: "",
          salesmanName: "",
          salesMobile: "",
          salesOrderNo: "", //出厂编号
          siteName: "",
          contact: "",
          siteMobile: "",
          natureNote: "",
          projectLeader: "",
          serviceAddress: "", //服务地址
          serviceQuantity: "", //服务台数
          submitTime: "", //提交日期
          managerApproveId: "", //提交日期
          siteDescription: "", //审核意见
          responsibilityDecide: "", //审核意见
          questionType: "", //审核意见
          mainBoardModel: "",
          transducerModel: "",
          causeNote: "",
          faultNote: "",
          isCharge: "",
          chargeDate: "",
          disagreeReasons: "",
          isCustomerAgree: "",
          chargeOrderNo: "",
          isDeferred: "",
          deferredTime: "",
          responsibilityDepartment: "",
          estimatedFinishTime: "",
          actualFinishTime: "",
          nodeId: "",
          attachments: [],
          delayTableData: [],
          appointmentItems1: [],
          appointmentItems2: [],
          appointmentPriceSheets: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getTemplateList();
      this.getNodeValue();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `appointmentOrders/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.appointmentOrderVO = resp;
            // console.log(this.appointmentOrderVO.siteAttachments);
            this.appointmentOrderVO.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.appointmentOrderVO.siteAttachments.forEach(row=>{
              if (row.filePath.includes("common")) {
                row.fileFullPath = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.srcList.push(row.fileFullPath);
                return row.fileFullPath;
              } else {
                row.fileFullPath = "https://emes.stepelectric.com" + row.filePath;
                console.log(row.fileFullPath);
                this.srcList.push(row.fileFullPath);
                return row.fileFullPath;
              }
            });
            this.appointmentOrderVO.signatureAttachments.forEach(item=>{
              item.fileFullPath = window.config.basicServerHttpUrl + "file/download?uuid=" + item.filePath + "&name=" + item.fileName;
              this.srcList.push(item.fileFullPath);
            });
          });
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentItemTemplates/getAllList")
          .then(resp => {
            this.appointmentItemTemplates1 = [];
            this.appointmentItemTemplates2 = [];
            resp.forEach(item=>{
              if (item.itemType === 10) {
                this.appointmentItemTemplates1.push(item);
              }else {
                this.appointmentItemTemplates2.push(item);
              }
            });
          });
      },
      addPriceSheets(row,index) {
        console.log(row,index);
        if (index>=0) {
          this.appointmentOrderVO.appointmentPriceSheets[index] = row;
        }else {
          this.appointmentOrderVO.appointmentPriceSheets.push(row);
        }

      },
      oneDeletePriceSheet(index) {
        this.appointmentOrderVO.appointmentPriceSheets.splice(index, 1);
      },
      //附件表页面删除
      oneDelete(row, index) {
        this.appointmentOrderVO.attachments.splice(index, 1);
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      handleSuccess(response, file, fileList) {
        console.log(file);
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.appointmentOrderVO.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      toDoApprove() {
        if (this.params.actionType ===0) {
          this.appointmentOrderVO.nodeId = this.nodeId;
          if (this.nodeId === "csApproveAppointment") {
            this.appointmentOrderVO.managerApproveId = parseInt(this.params.applicationVarVOS[0].varValue);
          }else if (this.nodeId === "csManagerApprove") {
            console.log(this.params);
            this.appointmentOrderVO.debugId = parseInt(this.params.applicationVarVOS[0].varValue);
          }
          this.updateItem();
        }
        this.doApprove();
      },
      doApprove() {
        //console.log(this.params.countersignVOS);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            this.sentWx(params.billId);
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/AppointmentApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      sentWx(pkid) {
        this.$http
          .get("basic", `appointmentOrders/sentWx/${pkid}/15`)
          .then(() => {
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.appointmentOrderVO.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `appointmentOrders/back/${this.appointmentOrderVO.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      updateItem() {
        this.appointmentOrderVO.nodeId = this.nodeId;
        this.$http
          .put("basic", "appointmentOrders/updateItem",this.appointmentOrderVO)
          .then(() => {});
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            if (this.nodeId==="siteSupport") {
              this.activeName = "second";
            }else if (this.nodeId==="quote") {
              this.activeName = "three";
            }else if (this.nodeId==="costConfirmation") {
              this.activeName = "fourth";
            }else {
              this.activeName = "first";
            }
          });
      },
    },
  };
</script>
<style lang="scss">
  table.ProjectOrderTable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  table.ProjectOrderTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProjectOrderTable td {
    padding: 8px;
    border-right: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
</style>
